var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.832 13.785c-.109.198-.247.385-.395.556-.315.362-.625.732-.974 1.058-.251.234-.564.403-.849.601h-.491c-.334-.077-.674-.133-1-.234-1.077-.334-2.026-.918-2.928-1.58-1.521-1.115-2.867-2.421-4.118-3.827-.888-1-1.698-2.056-2.318-3.247-.36-.693-.643-1.413-.73-2.197-.003-.022-.02-.042-.029-.063V4.36c.149-.364.384-.67.668-.931.443-.407.899-.8 1.36-1.187.217-.18.48-.258.768-.24.255.017.469.115.61.328.63.944 1.254 1.892 1.878 2.84.157.238.154.5.075.76-.044.144-.11.284-.18.417-.152.283-.29.578-.477.837-.186.26-.153.445.044.681 1.072 1.286 2.23 2.48 3.554 3.507.107.082.188.09.308.018.334-.203.677-.393 1.02-.58.138-.075.284-.14.433-.185.288-.088.56-.05.818.122.873.586 1.742 1.18 2.63 1.742.512.322.558.87.323 1.296",
    transform: "translate(-152 -863) translate(151 862)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneField);
export default __webpack_public_path__ + "static/media/phone-field.0debb062.svg";
export { ForwardRef as ReactComponent };